<template>
  <form-group
    class="dimensions-input"
    :label="label"
    :errors="internalErrors"
    @focus="focus"
  >
    <div uk-grid class="uk-grid-small">
      <div class="uk-width-small">
        <input
          ref="primaryInput"
          type="number"
          step="any"
          min="0"
          class="uk-input dimensions-input__width"
          :class="inputCss"
          v-model.number="internalValue.width"
          :disabled="disabled"
          @input="onInput"
          :placeholder="$t('fields.width')"
        >
      </div>
      <div class="dimensions-input__input-separator">
        &times;
      </div>
      <div class="uk-width-small">
        <input
          type="number"
          step="any"
          min="0"
          class="uk-input dimensions-input__height"
          :class="inputCss"
          v-model.number="internalValue.height"
          :disabled="disabled"
          @input="onInput"
          :placeholder="$t('fields.height')"
        >
      </div>
      <div class="dimensions-input__input-separator">
        &times;
      </div>
      <div class="uk-width-small">
        <input
          type="number"
          step="any"
          min="0"
          class="uk-input dimensions-input__depth"
          :class="inputCss"
          v-model.number="internalValue.depth"
          :disabled="disabled"
          @input="onInput"
          :placeholder="$t('fields.depth')"
        >
      </div>
      <div>
        <select
          class="uk-select dimensions-input__unit"
          v-model="internalValue.unit"
          @change="onInput"
        >
          <option v-for="unit in availableUnits" :value="unit">
            {{translateUnit(unit)}}
          </option>
        </select>
      </div>
    </div>
  </form-group>
</template>

<script>
import { camelCase, pick } from 'lodash';
import ComplexInput from '@/mixins/ComplexInput';

const AVAILABLE_UNITS = ['MM', 'CM'];

export default {
  name: 'dimensions-input',
  mixins: [ComplexInput],
  data() {
    let value;
    if (this.value) {
      value = pick(this.value, ['width', 'height', 'depth', 'unit']);
    } else {
      value = { width: null, height: null, depth: null, unit: null };
    }
    if (!value.unit) value.unit = AVAILABLE_UNITS[0];
    return { internalValue: value, availableUnits: AVAILABLE_UNITS };
  },
  computed: {
    valueIsPresent() {
      return this.internalValue &&
        this.internalValue.width &&
        this.internalValue.height;
    },
  },
  methods: {
    onInput() {
      let value = null;
      if (this.valueIsPresent) {
        value = pick(this.internalValue, ['width', 'height', 'depth', 'unit']);
        if (!value.depth) value.depth = null;
      }
      this.$emit('input', value);
    },
    translateUnit(unit) {
      return this.$t(`units.dimensions.${camelCase(unit)}`);
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          width: 'Breite',
          height: 'Höhe',
          depth: 'Tiefe',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../theme/variables.scss';

.dimensions-input__input-separator {
  font-size: 1.4rem;
  font-weight: normal;
  line-height: 2.4rem;
  color: $global-muted-color;
}
</style>



// WEBPACK FOOTER //
// DimensionsInput.vue?4f66ca11